const EMAIL_REGEX = new RegExp('^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$', 'gi');

export function deepCopy(data) {
    return JSON.parse(JSON.stringify(data));
}

export function compareInLC(string1, string2) {
    return string1.toLowerCase() === string2.toLowerCase();
}

export function getUnique(data) {
    return Array.from(new Set(data));
}

export function getClassName(classList) {
    return Array.from(classList).join(" ");
}

export function isEmailCorrect(string) {
    return EMAIL_REGEX.test(string);
}

export function serializeParams(params) {
    const mapped = Object.keys(params).map((key, index) => {
        const itemToConcat = params[key];

        if (itemToConcat !== null) {
            if (Array.isArray(itemToConcat)) {
                if (itemToConcat.length === 0) {
                    return '';
                }

                const itemToReturn = itemToConcat.reduce(
                    (memo, item, index) => {
                        if (index === itemToConcat.length - 1) {
                            return `${memo}${key}=${item}`;
                        }
                        return `${memo}${key}=${item}&`;
                    },
                    ''
                );

                if (index === 0) {
                    return itemToReturn;
                }

                return `&${itemToReturn}`;
            }

            if (index === 0) {
                return `${key}=${encodeURIComponent(itemToConcat)}`;
            }
            return `&${key}=${encodeURIComponent(itemToConcat)}`;
        }
        return '';
    });

    return mapped.join('');
}

// export function getRandomFromArray(myArray) {
//     return myArray[Math.floor(Math.random() * myArray.length)];
// }
//
// export function getRandomBetween(min, max) {
//     return Math.random() * (max - min) + min;
// }
//
// export function getRandomIntBetween(min, max) {
//     min = Math.ceil(min);
//     max = Math.floor(max);
//     return Math.floor(Math.random() * (max - min + 1)) + min;
// }

export function sliceArray(array, subArraysLength = 2) {
    const result = [];
    for (let i = 0; i < array.length / subArraysLength ; i++) {
        result.push(array.slice(i * subArraysLength, (i + 1) * subArraysLength));
    }
    return result;
}



export function isEmpty(obj) {
    return Object.keys(obj).length === 0;
}

export function getHalves(arr) {
    return [
        arr.slice(0, Math.ceil(arr.length / 2)),
        arr.slice(Math.ceil(arr.length / 2)),
    ];
}

export function toggleInArray(array, ...values) {
    let result = [...array];
    if (values.length === 0) return [];
    values.forEach((value) => {
        if (array.includes(value)) {
            result = result.filter((item) => item !== value);
        } else {
            result = [...result, value];
        }
    });
    return result;
}


export const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
}